import api from './';

/**
 * retorna situações por campo
 * @param {*} empresaId id da empresa ou padrão 1
 * @param {*} campo true para o campo informado
 * @returns
 */
export const situacao = async ({ empresaId = 1, campo, campos = [], operacaoSigla = null }) => {
    try {
        const params = { empresaId };

        // compatibilidade antiga
        if (campo) params.campo = campo;

        // novo padrão (preferencial)
        if (campos && campos.length) {
            params.campos = campos.join(',');
        }

        if (operacaoSigla) {
            params.operacaoSigla = operacaoSigla;
        }

        const { data } = await api.get('/serviceSituacao', { params });

        return data;
    } catch (error) {
        return error;
    }
};

/**
 * retorna todas as situações
 * @param {*} empresaId id da empresa ou padrão 1
 * @returns
 */
export const situacoes = async (empresaId = 1) => {
    try {
        const { data } = await api.get('/serviceSituacoes', { params: { empresaId } });
        return data;
    } catch (error) {
        return error;
    }
};
